
import axios from 'axios';
import { useQuery } from 'react-query';
import { PostPublication } from '../../../telegram-forum/model';
import { PostDto } from '../model'

const POST = `/api/admin/posts`;

export const useGetPosts = () => {
  return useQuery<PostDto[]>(
    ['posts'],
    async () => {
      const { data } = await axios.get(`${POST}/`);
      return data;
    },
    {
      refetchOnWindowFocus: false,
      // Отправка идёт фоновой задачей: пока что-то публикуется, обновляем
      // список сами — иначе статус в таблице так и останется «Публикуется»
      refetchInterval: data =>
        data?.some(post => post.publication?.status === 'pending') ? 5000 : false,
    },
  );
};

/**
 * Статус публикации поста в Telegram. Пока статус pending — опрашиваем
 * каждые 5 секунд: отправка идёт фоновой задачей, а не в ответе ручки.
 */
export const useGetPostPublication = (uuid?: string) => {
  return useQuery<PostPublication>(
    ['post-publication', uuid],
    async () => {
      const { data } = await axios.get(`${POST}/${uuid}/publish`);
      return data;
    },
    {
      enabled: Boolean(uuid),
      refetchOnWindowFocus: false,
      refetchInterval: data => (data?.status === 'pending' ? 5000 : false),
    },
  );
};
